import  { useEffect, useState } from "react";
import "../../../../../../css/CashflowModeller2/Cards/Income/IncomeCardSmall.css";
import "../../../../../../css/CashflowModeller2/Cards/Cards.css";
import AddEditButton from "../../Buttons/AddEditButton";
import { useCfmContext } from "../../../Context/CfmContext";
import { useContextUpdater } from "../../../Hooks/UseContextUpdater";
import DisplayMedium from "../../Inputs/DisplayMedium";
import PersonalDetailsDialogBox from "../../DialogBoxes/PersonalDetailsDialogBox"; // ← import dialog
import TimelineOptions from "../../../Utils/TimelineOptions";
import ArrowDown from "../../Buttons/ArrowDown";
import Input1Big from "../../Inputs/Input1Big";

/**
 * PersonalDetailCardSmall is a React functional component that displays a compact card
 * for managing and viewing personal details such as name and current expenditure.
 * 
 * Features:
 * - Displays a list of personal details, defaulting to a single empty entry if none exist.
 * - Allows users to add or edit personal details via a dialog box.
 * - Supports collapsing and expanding the card content.
 * - Disables input fields if no details are present.
 * - Integrates with context for state management and updating details.
 * 
 * @component
 * @returns {JSX.Element} The rendered PersonalDetailCardSmall component.
 */
const PersonalDetailCardSmall = () => {
  const { state } = useCfmContext();
  const details =
    state.details?.length > 0
      ? state.details
      : [
          {
            name: "",
            currentExpenditure: {
              value: "",
              unit: TimelineOptions[1].value,
            },
          },
        ];

  const { updateContextField, addItem, deleteItem } =
    useContextUpdater("details");

  const isDisabled = state.details?.length === 0;
  const [isDialogOpen, setIsDialogOpen] = useState(false); // ← dialog state
  // const [isCollapsed, setIsCollapsed] = useState( true);
  const [isCollapsed, setIsCollapsed] = useState(state.docId? false : true);

  // useEffect(() => {
  //   if (details.length === 0) {
  //     addItem({
  //       name: "",
  //       expenditure: "",
  //     });
  //   }
  // }, [details, addItem]);

  // useEffect(() => {
    // console.log(state);
  // }, [details]);

  return (
    <div className={`card-wrapper ${isCollapsed ? "collapsed" : ""}`}>
      <div className="card-rows card-header">
        <div className="Title">Personal Details</div>
        <div className="card-header-actions">
          <div className="relative-button-wrapper">
            <AddEditButton
              onClick={() => setIsDialogOpen(true)}
              buttonText={
                state.details?.length > 0
                  ? state.details?.length === 2
                    ? "Edit"
                    : "Add / Edit"
                  : "Add"
              }
            />
            {isDialogOpen && (
              <div className="dialog-overlay">
                <PersonalDetailsDialogBox
                  onClose={() => setIsDialogOpen(false)}
                />
              </div>
            )}
          </div>
          <div
            className={`arrow-toggle ${isCollapsed ? "rotate" : ""}`}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <ArrowDown />
          </div>
        </div>
      </div>
      <div
        className={`card-collapse-container ${isCollapsed ? "collapsed" : ""}`}
      >
        {details.map((detail, index) => (
          <div key={index} className="card-rows ">
            {/* <Input1 */}
            <DisplayMedium
              label={index === 0 ? "Name" : ""}
              // value={detail?.name}
              value={detail?.name.split(" ")[0]}
              onChange={(val) => updateContextField(index, "name", val)}
              isDisabled={isDisabled}
              // readOnly
            />
            <Input1Big
              label={index === 0 ? "Expenditure" : ""}
              type="number"
              value={detail?.currentExpenditure?.value}
              onChange={(val) =>
                updateContextField(index, "currentExpenditure", {
                  ...detail.currentExpenditure,
                  value: val,
                })
              }
              onUnitChange={(unit) =>
                updateContextField(index, "currentExpenditure", {
                  ...detail.currentExpenditure,
                  unit: unit,
                })
              }
              isDisabled={isDisabled}
              options={TimelineOptions}
              readOnly
              currency={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonalDetailCardSmall;
